import { render, staticRenderFns } from "./browse-genres.vue?vue&type=template&id=0bdf1f6c&scoped=true&"
import script from "./browse-genres.vue?vue&type=script&lang=js&"
export * from "./browse-genres.vue?vue&type=script&lang=js&"
import style0 from "./browse-genres.vue?vue&type=style&index=0&id=0bdf1f6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdf1f6c",
  null
  
)

export default component.exports